/**
 * MagnetPostCarousel — Instagram Carousel poszt-flow.
 *
 * Vékony wrapper a MagnetPostFacebook komponens fölött `platform="carousel"`
 * propal. A Carousel ügynök a Facebook Posztvarázsló REPLIKÁCIÓJA, a
 * következő Carousel-specifikus változtatásokkal:
 * - Backend: Outline Generator a 7 Carousel-szöget használja, a Writer a
 *   Carousel Master System Promptot kapja (2026-os IG algoritmus-optimalizált,
 *   „második esély" stratégia, dia-alapú strukturált output).
 * - Output: dia-alapú strukturált tartalomcsomag (tipus, hossz_dia, diak[],
 *   leiras, vizualis_utasitas, miert_mukodik, alternativ_horgok[]).
 * - Mentés: agent_type="post-carousel", forras_alkartya="carousel".
 */
import MagnetPostFacebook from "./MagnetPostFacebook";

export default function MagnetPostCarousel(props) {
  return <MagnetPostFacebook {...props} platform="carousel" />;
}
